//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation  } from "react-router-dom";

//css
import styled from "styled-components"

// component
import MyPoint from "./components/MyPoint"

export default function MyPointPage() {

    return (
        <MyPoint/>
    );
  }

